"use strict";

exports.__esModule = true;
var _Accordian = require("./Accordian");
Object.keys(_Accordian).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Accordian[key]) return;
  exports[key] = _Accordian[key];
});